import { render, staticRenderFns } from "./SecurityDisclosure.vue?vue&type=template&id=04922486&"
import script from "./SecurityDisclosure.vue?vue&type=script&lang=js&"
export * from "./SecurityDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports